export default {
  SET_DATA: '@YOLA_TEMPLATE_GALLERY/SITES/SET_DATA',
  FETCH_SITES_LIMIT: '@YOLA_TEMPLATE_GALLERY/SITES/FETCH_SITES_LIMIT',
  SET_SITES_LIMIT: '@YOLA_TEMPLATE_GALLERY/SITES/SET_SITES_LIMIT',
  SET_SITE_ID_RECREATE: '@YOLA_TEMPLATE_GALLERY/SITES/SET_SITE_ID_RECREATE',
  SET_SITE_ID_TO_SWITCH_TEMPLATE: '@YOLA_TEMPLATE_GALLERY/SITES/SET_SITE_ID_TO_SWITCH_TEMPLATE',
  SET_TEMPLATE_BUILD_SLUG: '@YOLA_TEMPLATE_GALLERY/SITES/SET_TEMPLATE_BUILD_SLUG',
};
